<template>
  <div >
    <div class=" is-fullwidth">
     
      <div class="is-pulled-right">
        <button class="button is-warning" @click="showCompleteError()" style="display:none">Export to CSV</button>
      </div>
    </div>

    <div class="notification is-info" v-if="loading == true " style="clear:both">Loading requests ...</div>

    <div class="notification is-success" v-if="loading == false && this.samples.length == 0 " style="clear:both">There are no requests to show. This is great, we're all up to date.</div>

    <div v-if="loading==false && this.newSamples.length > 0" class="mb-6">
        <h2 class="title" v-if="this.area == 'new'">New Samples (Requires Action)</h2>
         <h2 class="title" v-else>In Progress (Requires Action)</h2>
    
      <ListSamplesTable :samples="newSamples" @open-modal="openProcessModal"/>

      
    </div>

    <div v-if="loading==false && this.waitingSamples.length > 0">
        <h2 class="title">Returned Samples (Waiting For Requestor)</h2>
    
      <ListSamplesTable :samples="waitingSamples" @open-modal="openProcessModal"/>

    </div>
    
    <ProcessSampleModal :showProcessModal="showProcessModal" @hide-modal="showProcessModal=false" @reload-samples="getNewSamples()" :sample_id="selected_sample_id"/>
    
  </div>
</template>

<script>


import OrderService from '@/services/OrderService.js';
import SampleService from '@/services/SampleService.js';
//import UtilityService from '@/services/UtilityService.js';

import OrderMixin from "@/mixins/OrderMixin.js";

import ProcessSampleModal from "./ProcessSampleModal.vue";
import ListSamplesTable from "./ListSamplesTable.vue";

export default {
  components: {
        ProcessSampleModal,
        ListSamplesTable
      },
  mixins: [OrderMixin],
  data() {
    return {
       errors: [],
      orders: [],
      showModal: false,
      selectedOrderID: 0,
      working :false,
      loading: true,
      ASP_URL : process.env.VUE_APP_ASP_URL,
      cutting_rooms: [],
      makeuplocations: [],
      order_by: 'deliverydate ASC',
      cutting_location_id: 'allset',
      limit: '',
      showProcessModal: false,
      samples: [],
      selected_sample_id: 0
    }
  },
   methods: {
    openProcessModal(sample_id) {
      //alert(sample_id)
      //console.log("openProcessModal triggered:", sample_id);
      this.selected_sample_id = sample_id;
      this.showProcessModal = true;
    },
    showCompleteError() {
        alert("This button does not action anything. ")
    },
    viewRequest(id)
    {
        this.$router.push("/samples/view/" + id);
    },
      async getNewSamples() {
        this.sample_id = "-1"
        this.showProcessModal=false
        this.loading=true
        SampleService.getNewSamples(this.accessToken)
        .then(
          (samples => {
            this.$set(this, "samples", samples);
            this.loading=false
          }).bind(this)
        );
      },
      async getInProgressSamples() {
        this.sample_id = "-1"
        this.showProcessModal=false
        this.loading=true
        SampleService.getInProgressSamples(this.accessToken)
        .then(
          (samples => {
            this.$set(this, "samples", samples);
            this.loading=false
          }).bind(this)
        );
      },
       async updateMarker(order) {
        this.working = true
        
        var order_id = order.orderID
       

        var formdata = { 
            _method: 'patch',
             marker_received: 1
        }; 

        OrderService.updateOrder(this.accessToken, order_id, formdata)
        .then(() => {
            this.working = false
            //console.log(response)
            order.marker_received = 1
        }).catch((error) => {
           alert("Something went wrong and the order has not been updated. Please reload and try again")
            console.log("Error:" + JSON.stringify(error.response.data));
            this.working = false
        });
    },   
   
    
  },
  computed : {
      newSamples: function () {
       
        let newSamples =  this.samples.filter(function(u) {
            if(  u.returned == 0) 
            {
              return 1
            }
          })
          
          return newSamples
       
     },
     waitingSamples: function () {
       
        let waitingSamples =  this.samples.filter(function(u) {
            if(  u.returned == 1) 
            {
              return 1
            }
          })
          
          return waitingSamples
       
     },
  
     area: function() {
        if(this.$route.path == '/samples/list-samples/new')
        {
            return "new"
        }
        else if(this.$route.path == '/samples/list-samples/inprogress')
        {
            return "inprogress"
        }
        else {
          return ""
        }
    }
  },

  // Fetches posts when the component is created.
  created() {
     this.getAccessToken()
        .then(() => { 
          if(this.area == "new")
          {
           this.getNewSamples()
          }
          else {
            this.getInProgressSamples()
          }
        });
  },
 
  mounted() {
    
      
  },
  watch: {
    
  }
}


</script>

